export default __webpack_public_path__ + "static/media/excel2019.e246cd0a.png";